import React from "react";
import Slider from "react-input-slider";
import { NotificationManager } from "react-notifications";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Switch from "react-switch";
import { addConfig, setDefaultConfig, updateConfig } from "../../actions/configuration";

class ImageCompressor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userSelectedQuality: 80,
      imageQuality: 80,
      imageFormat: "jpeg",
      imageQualityAlertMessage: "Best Quality (Larger file size)",
      isCustomCompressEnabled: false,
      compressConfigId: "",
      compressInfo: {},
      disableImageCompression: false,
    };
  }

  onChange = (event) => {
    let selectedQuality = parseInt(event.x);

    // Set the image quality
    if (selectedQuality < 30) {
      this.setState({ imageQuality: 50, userSelectedQuality: selectedQuality });
    } else {
      this.setState({ imageQuality: selectedQuality, userSelectedQuality: selectedQuality });
    }

    // Set the image quality alert message
    if (selectedQuality > 70 && selectedQuality <= 100) {
      this.setState({ imageQualityAlertMessage: "Best Quality (Larger file size)" });
    } else if (selectedQuality > 40 && selectedQuality <= 70) {
      this.setState({ imageQualityAlertMessage: "Medium Quality (Average file size)" });
    } else {
      this.setState({ imageQualityAlertMessage: "Less Quality (Smaller file size)" });
    }
  };

  onDisableImageCompressionChange = (checked) => {
    this.setState({ disableImageCompression: checked });

    if (!checked) {
      this.setState({
        userSelectedQuality: 100,
        imageQuality: 100,
        imageFormat: "jpeg",
        isCustomCompressEnabled: false,
      });
    } else {
      this.setState({
        userSelectedQuality: 80,
        imageQuality: 80,
        imageFormat: "jpeg",
        isCustomCompressEnabled: false,
      });
    }
  };

  changeVal = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  updateImageCompression = (event) => {
    if (event.target.name === "customCompress") {
      this.setState(
        {
          isCustomCompressEnabled: event.target.checked,
        },
        () => {
          if (!this.state.isCustomCompressEnabled) {
            this.setState({ imageQuality: 80, userSelectedQuality: 80, imageFormat: "jpeg" });
          }
        }
      );
    }
  };

  saveImageCompression = (event) => {
    event.preventDefault();

    const {
      isCustomCompressEnabled,
      compressConfigId,
      imageQuality,
      userSelectedQuality,
      imageFormat,
      disableImageCompression,
    } = this.state;

    let extension, contentType;

    switch (imageFormat) {
      case "jpeg":
        extension = ".jpeg";
        contentType = "image/jpeg";
        break;
      case "webp":
        extension = ".webp";
        contentType = "image/webp";
        break;
      case "png":
        extension = ".png";
        contentType = "image/png";
        break;
      default:
        extension = ".jpeg";
        contentType = "image/jpeg";
    }

    let compressInfo = {
      format: imageFormat,
      extension: extension,
      contentType: contentType,
      quality: imageQuality,
      userSelectedQuality: userSelectedQuality,
      isCustomCompressEnabled: isCustomCompressEnabled,
      isCompressionEnabled: disableImageCompression,
    };

    let configData = {
      type: "petshop",
      name: "image_compression_terms",
      value: JSON.stringify(compressInfo),
    };

    if (compressConfigId) {
      if (isCustomCompressEnabled) {
        if (imageQuality >= 1 && imageQuality <= 100) {
          this.props.updateConfig(compressConfigId, configData);
        } else {
          NotificationManager.warning("Please enter a number between 1 - 100");
        }
      } else {
        this.props.updateConfig(compressConfigId, configData);
      }
    } else {
      let newCompressInfo = {
        format: imageFormat,
        extension: extension,
        contentType: contentType,
        quality: imageQuality,
        userSelectedQuality: userSelectedQuality,
        isCustomCompressEnabled: isCustomCompressEnabled,
        isCompressionEnabled: disableImageCompression,
      };

      let newConfigData = {
        type: "petshop",
        name: "image_compression_terms",
        value: JSON.stringify(newCompressInfo),
      };
      // Add new image configuration
      this.props.addConfig(newConfigData);
    }
  };

  componentWillReceiveProps = (nextProps) => {
    if (this.props.data.configs !== nextProps.data.configs) {
      let configs = nextProps.data.configs;

      if (configs.length < 1) {
        this.props.setDefaultConfig();
      }

      for (let item of configs) {
        if (item.name === "image_compression_terms") {
          let configData = JSON.parse(item.value);

          this.setState(
            {
              compressConfigId: item.id,
              imageQuality: configData.quality,
              imageFormat: configData.format,
              userSelectedQuality: configData.userSelectedQuality,
              isCustomCompressEnabled: configData.isCustomCompressEnabled,
              disableImageCompression: configData.isCompressionEnabled,
              compressInfo: {
                quality: configData.quality ? configData.quality : this.state.imageQuality,
                isCustomCompressEnabled: configData.isCustomCompressEnabled
                  ? configData.isCustomCompressEnabled
                  : this.state.isCustomCompressEnabled,
              },
            },
            () => {
              let selectedQuality = parseInt(this.state.userSelectedQuality);
              if (selectedQuality > 70 && selectedQuality <= 100) {
                this.setState({ imageQualityAlertMessage: "Best Quality (Larger file size)" });
              } else if (selectedQuality > 40 && selectedQuality <= 70) {
                this.setState({ imageQualityAlertMessage: "Medium Quality (Average file size)" });
              } else {
                this.setState({ imageQualityAlertMessage: "Less Quality (Smaller file size)" });
              }

              let isCompressionEnabled = this.state.disableImageCompression;
              if (!isCompressionEnabled) {
                this.setState({ userSelectedQuality: 100, imageQuality: 100, imageFormat: "jpeg" });
              }
            }
          );
          break;
        }
      }
    }
  };

  render() {
    return (
      <div>
        <div className="m-portlet__body">
          <div className="row">
            <div className="col-md-6 mt-auto">
              <p>Enable Image Compression</p>
            </div>
            <div className="col-md-6">
              <Switch
                onChange={this.onDisableImageCompressionChange}
                checked={this.state.disableImageCompression}
                uncheckedIcon={false}
                checkedIcon={false}
                onColor={"#28a745"}
              />
            </div>
          </div>

          {this.state.disableImageCompression ? (
            <>
              <div className="m-widget4__item percentage-input">
                <span className="m-widget4__sub">
                  <label className="m-checkbox m-checkbox--bold m-checkbox--state-success">
                    <input
                      onChange={this.updateImageCompression}
                      checked={this.state.isCustomCompressEnabled}
                      type="checkbox"
                      name="customCompress"
                    />
                    Enable custom image compression
                    <span></span>
                  </label>
                </span>
              </div>
              <div className="form-row">
                <div className="form-group col-md-12">
                  <div className="input-group">
                    <lable className="col-sm-3 col-form-label">Image Format</lable>
                    <select
                      type="text"
                      name="imageFormat"
                      onChange={this.changeVal}
                      className="form-control m-input "
                      disabled={!this.state.isCustomCompressEnabled}
                      value={this.state.imageFormat}
                    >
                      <option value="jpeg">JEPG (Default)</option>
                      {/* Commented because WordPress currently does not support Webp */}
                      {/* <option value="webp">WEBP</option> */}
                      <option value="png">PNG</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="form-group col-md-12">
                  <div className="input-group">
                    <lable className="col-sm-3 col-form-label">Image Quality</lable>
                    <div className="image-quality-slider mt-3">
                      <Slider
                        axis="x"
                        xmin={1}
                        xmax={100}
                        x={this.state.userSelectedQuality}
                        xstep={1}
                        onChange={this.onChange}
                        disabled={!this.state.isCustomCompressEnabled}
                      />
                    </div>
                    <lable className="col-sm-3 col-form-label">
                      <strong>{this.state.userSelectedQuality}%</strong>
                    </lable>
                  </div>
                </div>
              </div>
              <div className="image-quality-message">
                <span>{this.state.imageQualityAlertMessage}</span>
              </div>
            </>
          ) : null}
        </div>

        <div className="m-portlet__foot m-portlet__foot--fit">
          <div className="m-form__actions m--align-right">
            <button
              onClick={this.saveImageCompression}
              className="btn btn-primary m-btn m-btn--icon m-btn--pill"
            >
              <span>
                <i className="la la-save"></i>
                <span>Save</span>
              </span>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  data: state.configReducer,
});

const mapDispatchToProps = (dispatch) => ({
  updateConfig: (id, data) => {
    dispatch(updateConfig(id, data));
  },
  addConfig: (data) => {
    dispatch(addConfig(data));
  },
  setDefaultConfig: () => {
    dispatch(setDefaultConfig());
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ImageCompressor));
